const RuleToFilter = {
  source: (rule, name) => {
    const sources = /^artists|styles|languages|tags|instruments|vocalInstruments|boxes$/g;
    return rule.field.name.match(sources) ? rule.field.name : 'tracks'
  },
  type: (rule, name) => {
    switch (true) {
      case /title|artistName|description/.test(name):
        return 'string';
      case /duration|publicationDate/.test(name):
        return 'range';
      case /bpm|year/.test(name):
        return rule.comparison === 'equals' ? 'ValueList' : 'range';
      default:
        return 'ValueList';
    }
  },
  operator: (rule, name) => {
    switch (true) {
      case /^duration|publicationDate$/.test(name):
        return null;
      case /^artists|languages|styles|labels|tags|instruments|vocalInstruments|boxes|sources$/.test(name):
        return 'equals';
      case /^exc-sources$/.test(name):
        return 'not in';
      case /^bpm|year$/.test(name):
        return rule.comparison === 'equals' ? 'equals' : null;
      default:
        return rule.comparison;
    }
  },
  fieldName: (rule, name) => {
    switch (true) {
      case /stationUid|sources|exc-sources/.test(name): return "uid";
      case /gender/.test(name): return 'genderId';
      case /languages/.test(name): return 'language';
      case /type/.test(name): return 'typeID';
      case /labels/.test(name): return 'labelID';
      case /artistName/.test(name): return 'artist';
      case /boxes/.test(name): return 'uid';
      case /^artists|styles|tags|instruments|vocalInstruments$/.test(name): return 'id';
      default: return rule.field.name;
    }
  },
  include: (rule, name) => {
    switch (true) {
      case /^artists|languages|styles|labels|tags|instruments|vocalInstruments|boxes$/.test(name):
        return rule.comparison === 'include';
      case /bpm|year$/.test(name):
        return rule.comparison === 'equals';
      default:
        return true;
    }
  },
  values: (rule, name) => {
    switch (true) {
      case /title|artistName|description/.test(name):
        console.log("Rule to split :", rule.value)
        return Array.isArray(rule.value)?rule.value: rule.value.split(', ');
      case /bpm|year/.test(name) && rule.comparison === 'equals':
        return rule.value ? rule.value.split(', ').map((value) => parseInt(value, 10)) : null
      case /type/.test(name):
        return rule.value.map(item => item.value);
      case /isExplicit/.test(name):
        return [rule.value];
      case /mood|energy|gender/.test(name):
        return [...rule.value];
      case /languages/.test(name):
        return rule.value.map(item => item.code).filter(item => item != null);
      case /boxes/.test(name):
        return rule.value.map(item => item.uid).filter(item => item != null);
      case /^artists|styles|labels|tags|instruments|vocalInstruments$/.test(name):
        return rule.value.map(item => item.id).filter(item => item != null);
      default:
        return [];
    }
  },
  from: (rule, name) => {
    switch (true) {
      case /duration/.test(name):
        switch (rule.comparison) {
          case 'greater':
          case 'equals':
            return parseInt(rule.value, 10);
          case 'between':
            return parseInt(rule.value.from, 10);
          default:
            return null;
        }
      case /bpm|year/.test(name):
        switch (rule.comparison) {
          case 'greater':
            return parseInt(rule.value, 10);
          case 'between':
            return parseInt(rule.value.from, 10);
          default:
            return null;
        }

      case /publicationDate/.test(name):
        return rule.comparison === 'greater' || rule.comparison === 'equals' ? rule.value : null;

      default:
        return null;
    }
  },
  to: (rule, name) => {
    switch (true) {
      case /duration/.test(name):
        switch (rule.comparison) {
          case 'lower':
          case 'equals':
            return parseInt(rule.value, 10);
          case 'between':
            return parseInt(rule.value.to, 10);
          default:
            return null;
        }

      case /bpm|year/.test(name):
        switch (rule.comparison) {
          case 'lower':
            return parseInt(rule.value, 10);
          case 'between':
            return parseInt(rule.value.to, 10);
          default:
            return null;
        }

      case /publicationDate/.test(name):
        return rule.comparison === 'lower' || rule.comparison === 'equals' ? rule.value : null;
      default:
        return null;
    }
  },
}

export default RuleToFilter;
